module.exports = __webpack_public_path__ + "img/width-narrow@2x.e1a1ced.webp";